<div class="finance">
    <p class="car-suggestion-text">It looks like you can get from</p>
    <p class="car-suggestion-price">{{ vehicle.monthlyPayments| currency:'GBP'}} </p>
    <p class="car-suggestion-per-month">per month</p>
    <p class="car-suggestion-monthly-payment">60 monthly payments over 5 years</p>
    <p class="car-suggestion">Not found a vehicle yet? What about these?</p>
  </div> 